import {createContext} from 'react'

export interface IWakeLockContext {
  requestWakeLock: () => Promise<void>
  releaseWakeLock: () => Promise<void>
}

export const WakeLockContext = createContext<IWakeLockContext>({
  requestWakeLock: async () => {},
  releaseWakeLock: async () => {},
})
